// A year's people sheet (rows, headers first) → {name: record}: the Gallery and the speaker
// dialog (SpeakerDialog.vue). Moved unchanged from Gallery.vue.
import moment from "moment";
import stringify from "json-stringify-safe";
import {getAffiliationWithCodes, getCountryCode} from "@/components/People/countryCodes";

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line

const formatDay = (dateString) => {
  return moment(dateString, "DD/MM/YYYY").format("ddd-DD");
};

// a person's sessions, "; " between them: "Cellular Systems" shortened; a delivery's variants
// one ("Virtual Workshop (A)" and "(B)" → "Virtual Workshop": Seán, 2026-11-03, the deliveries
// online, virtual and in person, not their groups), each session once
const regularizeCategoryNames = (person) => {
  if (!person.Category) return person.Category;
  const sessions = String(person.Category).split(/\s*[;,]\s*/).map((session) => {
    if (session === "Cellular Systems") return "Cells";
    return session.replace(/\s*\([A-Z]\)\s*$/, "");
  });
  return [...new Set(sessions)].join("; ");
};

export const getPeopleRecords = (peopleArray) => {
  if (!peopleArray || Object.keys(peopleArray).length === 0) {
    return {}; // early exit when called before mount
  }
  let people = {}; // the main output
  let properties = peopleArray[0]; // read properties from first row
  properties = properties.map((property) => property.replace(/^Talk.*/i, "Topic"));
  log(`properties = ${stringify(properties)}`);
  let rowIndex;
  // skip first row containing headers
  for (rowIndex = 1; rowIndex < peopleArray.length; rowIndex++) {
    let rowData = peopleArray[rowIndex];
    let columnIndex; // this is column count
    let name = "";
    let person = {};
    for (columnIndex = 0; columnIndex < properties.length; columnIndex++) {
      if (!rowData[columnIndex]) {
        log("warning: no data");
        continue;
      } else if (properties[columnIndex].match(/name/i)) {
        log(`Found a person's name: ${rowData[columnIndex]}`);
        name = rowData[columnIndex];
      } else if (properties[columnIndex].match(/date/i)) {
        person[properties[columnIndex]] = formatDay(rowData[columnIndex]);
      } else if (properties[columnIndex] === "Description") {
        if (rowData[columnIndex]) {
          // if there is a description for this speaker's talk
          // store it in a new object, with session name as key
          person["Description"] = {};
          person["Description"][person["Category"]] = rowData[columnIndex];
        }
      } else {
        person[properties[columnIndex]] = rowData[columnIndex];
      }
    }
    person.Category = regularizeCategoryNames(person);
    // countries as two-letter codes: "UZH, Switzerland" → "UZH, CH" (countryCodes.js)
    person.Affiliation = getAffiliationWithCodes(person.Affiliation);
    if (person.Country) person.Country = getCountryCode(person.Country) || person.Country;
    if (people[name]) {
      // if this person appears twice in this group, merge categories
      if (String(people[name]["Category"]).split(/\s*;\s*/).includes(person["Category"])) {
        // category already listed: keep the merged list
        person["Category"] = people[name]["Category"];
      } else {
        person["Category"] = people[name]["Category"] + "; " + person["Category"];
      }
      // also merge dates
      if (person["Date"] !== people[name]["Date"]) {
        // but only if the dates are different
        person["Date"] = people[name]["Date"] + "; " + person["Date"];
      }
      // also merge titles
      person["Topic"] = people[name]["Topic"] + "; " + person["Topic"];
      if (people[name]["Description"]) {
        // if the previous array item for this person had a descriptions
        // store with current description in new object
        person["Description"] = {
          ...people[name]["Description"],
          ...person["Description"]
        };
      }
    }
    if (!name.match(/\?/) && !name.match(/^T.?B.?A.?$/i)) {
      // Exclude names with questions marks or 'T.B.A.'
      people[name] = person;
    }
  }
  if (Object.keys(people).length > 0) {
    return people;
  } else {
    return null;
  }
};
